import { SplashState } from '@/state/SplashState';
import { useDispatch, useSelector } from '@/state/store';
import { useCallback } from 'react';
import { changeSplash as _changeSplash } from '../../actions/splashActions';
import * as selectors from '../../selectors/selectors';
import NotificationDialog from '../notification/NotificationDialog';
import { PreferencesDialog } from '../preferences/PreferencesDialog';
import { Changelog } from './Changelog';
import { PrivacyPolicy } from './PrivacyPolicy';
import { Splash } from './Splash';

const LogoAndSplash = () => {
    const windowOpen = useSelector(selectors.stateSplash);
    const dispatch = useDispatch();

    const changeSplash = useCallback(
        (splash: SplashState) => {
            dispatch(_changeSplash(splash));
        },
        [dispatch]
    );

    const SplashDialog = useCallback(() => {
        switch (windowOpen) {
            case SplashState.MAIN:
                return <Splash handleWindowChange={changeSplash} />;
            case SplashState.POLICY:
                return <PrivacyPolicy handleWindowChange={changeSplash} />;
            case SplashState.CHANGELOG:
                return <Changelog handleWindowChange={changeSplash} />;
            case SplashState.PREFERENCES:
                return <PreferencesDialog handleWindowChange={changeSplash} />;
            case SplashState.NOTIFICATION:
                return <NotificationDialog handleWindowChange={changeSplash} />;
            default:
                return <></>;
        }
    }, [windowOpen, changeSplash]);

    if (windowOpen === SplashState.NONE) return;
    return (
        <div className="c-splash-and-logo">
            <SplashDialog />
        </div>
    );
};

export default LogoAndSplash;
